<template>
  <div style="background-color: #F9FBFD;">
    <div class="course_header">
      <div class="course_header_img">
        <img src="../assets/banner-1.png" alt="">
      </div>
      <div class="course_header_title" id="course_header_title">
        <div class="course_header_box"
          :style="index == titIndex || Number(index) + 6 == titIndex  ? 'color: #1D2B3E;' : ''"
          v-for="(item,index) in titleList" :key="index" @click="handleSelect(index)">
          <span>{{item.name}}</span>
        </div>
        <div class="tab-activation-item" :style="{
          		left: (courseleft + 338)+'px',
          	}"></div>
        <div class="course_header_title_board">
          <div style="font-size: 24px;color: #ffffff;margin-bottom: 7px;">Curriculum</div>
          <div style="width: 48px;height: 3px;background-color: #ffffff;margin-bottom: 5px;"></div>
          <div style="font-size: 24px;color: #ffffff;">课程</div>
        </div>
      </div>
      <div v-if="titIndex == 0">
        <div class="w">
          <div class="course_content_box">
            <div class="course_content_box_item" v-for="(item, key) in queryInfolist1" :key="key" @click="gomedicine">
              <div class="course_content_box_item_img">
                <el-image style="width: 260px; height: 146px;" :src="item.imageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="course_content_box_item_box">
                <span>{{item.name}} <button v-if="key == 0" class="course_content_box_item_box_btn">最热</button><button v-if="key == 1" class="course_content_box_item_box_btn">最新</button></span>
                <span>{{item.speakers}}</span>
                <span>{{item.brief}}</span>
                <span>{{item.joinPlanNum}}人参加</span>
              </div>
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total1" :page-size="queryInfo1.pageSize"
              :current-page="queryInfo1.pageNum" @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="titIndex == 1">
        <div class="w">
          <div class="course_content_box">
            <div class="course_content_box_item" v-for="(item, key) in queryInfolist2" :key="key" @click="gomedicine">
              <div class="course_content_box_item_img">
                <el-image style="width: 260px; height: 146px;" :src="item.imageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="course_content_box_item_box">
               <span>{{item.name}} <button v-if="key == 0" class="course_content_box_item_box_btn">最热</button><button v-if="key == 1" class="course_content_box_item_box_btn">最新</button></span>
                <span>{{item.speakers}}</span>
                <span>{{item.brief}}</span>
                <span>{{item.joinPlanNum}}人参加</span>
              </div>
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total2" :page-size="queryInfo2.pageSize"
              :current-page="queryInfo2.pageNum" @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2">
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-if="titIndex == 2">
        <div class="w">
          <div class="course_content_box">
            <div class="course_content_box_item" v-for="(item, key) in queryInfolist3" :key="key" @click="gomedicine">
              <div class="course_content_box_item_img">
                <el-image style="width: 260px; height: 146px;" :src="item.imageUrl" :fit="fit">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="course_content_box_item_box">
                <span>{{item.name}} <button v-if="key == 0" class="course_content_box_item_box_btn">最热</button><button v-if="key == 1" class="course_content_box_item_box_btn">最新</button></span>
                <span>{{item.speakers}}</span>
                <span>{{item.brief}}</span>
                <span>{{item.joinPlanNum}}人参加</span>
              </div>
            </div>
          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total3" :page-size="queryInfo3.pageSize"
              :current-page="queryInfo3.pageNum" @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3">
            </el-pagination>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        fit: 'fill',
        titleList: [{
            name: '师资培训课程',
            value: 0
          },
          {
            name: 'SP培训课程',
            value: 1
          },
          {
            name: '学生示教',
            value: 1
          }
        ],
        titIndex: 0,
        coursewidth: 0,
        courseheight: 4,
        courseleft: 0,
        classifyId: 1,
        queryInfo1: {
          classifyId: 2,
          pageNum: 1,
          pageSize: 10
        },
        queryInfo2: {
          classifyId: 1,
          pageNum: 1,
          pageSize: 10
        },
        queryInfo3: {
          classifyId: 3,
          pageNum: 1,
          pageSize: 10
        },
        total1: 0,
        total2: 0,
        total3: 0,
        queryInfolist1: [],
        queryInfolist2: [],
        queryInfolist3: []
      }
    },
    watch: {
      titIndex(newVal) {
        this.titIndex = newVal
        this.$nextTick(() => {
          this.init()
        })
        if (this.titIndex == 0) {
          this.getofficialcourselist1()
        } else if (this.titIndex == 1) {
          this.getofficialcourselist2()
        } else if (this.titIndex == 2) {
          this.getofficialcourselist3()
        }
      }
    },
    mounted() {

    },
    created() {
      if (this.$route.query.place) {
        this.titIndex = this.$route.query.place
      } else {
        this.titIndex = 0
        this.getofficialcourselist1()
      }

    },
    methods: {
      gomedicine() {
        window.open('https://zjh.zhihuiyijiao.com/', '_blank')
      },
      handleSizeChange1(newSize) {
        this.queryInfo1.pageSize = newSize
        this.getofficialcourselist1()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange1(newPage) {
        this.queryInfo1.pageNum = newPage
        this.getofficialcourselist1()
      },
      handleSizeChange2(newSize) {
        this.queryInfo2.pageSize = newSize
        this.getofficialcourselist2()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange2(newPage) {
        this.queryInfo2.pageNum = newPage
        this.getofficialcourselist2()
      },
      handleSizeChange3(newSize) {
        this.queryInfo3.pageSize = newSize
        this.getofficialcourselist3()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange3(newPage) {
        this.queryInfo3.pageNum = newPage
        this.getofficialcourselist3()
      },
      async getofficialcourselist1() {
        let res = await this.$Http.officialcourselist(this.queryInfo1)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist1 = res.data.data.list
        this.total1 = res.data.data.total
      },
      async getofficialcourselist2() {
        let res = await this.$Http.officialcourselist(this.queryInfo2)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist2 = res.data.data.list
        this.total2 = res.data.data.total
      },
      async getofficialcourselist3() {
        let res = await this.$Http.officialcourselist(this.queryInfo3)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist3 = res.data.data.list
        this.total3 = res.data.data.total
      },
      handleSelect(index) {
        this.titIndex = index
        this.$router.push({
          query: {
            place: this.titIndex
          }
        })
      },
      init() {
        let data = document.getElementsByClassName('course_header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          let titIndexnum = 0
          if (Number(this.titIndex) > 5) {
            this.coursewidth = arr[Number(this.titIndex) - 6]
            titIndexnum = Number(this.titIndex) - 6
          } else {
            this.coursewidth = arr[this.titIndex]
            titIndexnum = this.titIndex
          }

          this.courseleft = arr.slice(0, titIndexnum).reduce((num, item) => {
            return num + item + 70
          }, 0)
          document.getElementById('course_header_title').scrollLeft = this.courseleft - arr[this
            .titIndex] / 2;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .w {
    width: 1200px !important;
    margin: 0 auto;
  }

  .course_header {
    width: 100%;
    position: relative;
  }

  .course_header_img {
    width: 100%;
    img {
      width: 100%;
    }
  }

  .course_header_title {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
    height: 85px;
    padding-left: 348px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    background-color: #ffffff;
  }

  .course_header_title_board {
    position: absolute;
    left: 0;
    top: -84px;
    width: 269px;
    height: 169px;
    background-color: #1A7BFC;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 27px;
  }

  .course_header_box {
    display: inline-block;
    color: #808080;
    font-size: 16px;
    cursor: pointer;
    margin-right: 70px;
    z-index: 99;
  }

  .tab-activation-item {
    background: #1D2B3E;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .course_content_box {
    width: 100%;
    height: 100%;
    padding: 40px 0;

  }

  .course_content_box_item {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    height: 195px;
    background-color: #ffffff;
    display: flex;
    cursor: pointer;
  }

  .course_content_box_item_img {
    width: 260px;
    height: 146px;
    margin-right: 24px;

  }

  .course_content_box_item_box {
    width: 867px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .course_content_box_item_box span:nth-child(1) {
    font-size: 18px;
    font-weight: 600px;
    color: #395172;
    display: flex;
  }

  .course_content_box_item_box span:nth-child(2) {
    font-size: 14px;
    color: #8693A4;
  }

  .course_content_box_item_box span:nth-child(3) {
    font-size: 12px;
    color: #8693A4;
  }

  .course_content_box_item_box span:nth-child(4) {
    font-size: 12px;
    color: #8693A4;
  }

  .course_content_box_item_box_btn {
    padding: 2px 5px;
    box-sizing: border-box;
    border-radius: 2px;
    background: rgba(255, 35, 57, 0.1);
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: normal;
    border: 0;
    color: #FF2339;
    margin-left: 8px;
  }

  .news-footer {
    width: 100%;
    padding: 50px;
    box-sizing: border-box;
    text-align: center;
  }

  /deep/ .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 128px;
    }
  }
</style>
